
import { Component, Emit, Vue } from "vue-property-decorator";

@Component
export default class AppraiserEmptyState extends Vue {
  @Emit("click")
  clicked() {}
}
